import React, { useEffect, useRef } from 'react';
import MessageDiv from 'components/molecules/MessageDiv';
import { useSelectChatBottom } from 'modules/hooks';
import { useSelector } from 'react-redux';

/**
 * Chatting:Middle
 */
const ChatMiddle = () => {
  const chatResult = useSelector(state => state.chatList);
  const messageSet = chatResult.data;
  const messageBoxRef = useRef();

  function handleKeyDown(e) {
    if (e.keyCode === 37 || e.keyCode === 39) {
      const el = Array.from(document.querySelectorAll('#searchSlider')).pop();
      if (el) {
        el.focus();
      }
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  useSelectChatBottom();

  return (
    <section className="_chat_middle">
      <div className="_message_div">
        <div className="_message_layout scroll_style_messenger" id="scrollToElement" ref={messageBoxRef}>
          {messageSet.map((item, idx) => {
            return <MessageDiv key={item.messageId} message={item} index={idx} />;
          })}
        </div>
      </div>
    </section>
  );
};

export default ChatMiddle;
